export class CardAccordion {
	constructor ($root: HTMLElement) {
		const $chevron = $root.querySelector('.card-accordion__chevron') as HTMLElement;
		$chevron.addEventListener('click', () => $root.classList.toggle('open'))
	}
}